export default __webpack_public_path__ + "static/media/FoodChainGrassland_04.f109d276.png";